import { Link, useLocation } from "react-router-dom";
import { FaChartBar, FaClipboardList, FaUser } from "react-icons/fa";
import { useUser } from "../../../context/UserContext";
import UserAvatar from "../../common/UserAvatar";

const SellerBottomNav = () => {
  const location = useLocation();
  const { user } = useUser();

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const NavItem = ({ path, exact, icon: Icon, name }) => {
    const active = isActive(path, exact);
    return (
      <Link
        to={path}
        className={`flex flex-col items-center justify-center flex-1 h-full transition-colors duration-200 ${
          active ? "text-slate-900" : "text-slate-400 hover:text-slate-600"
        }`}
      >
        <Icon className="w-5 h-5" />
        <span className="text-[10px] mt-1 font-medium leading-none">
          {name}
        </span>
      </Link>
    );
  };

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-lg lg:hidden pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center h-16 px-2">
        <NavItem
          path="/seller/dashboard"
          exact
          icon={FaChartBar}
          name="Dashboard"
        />
        <NavItem
          path="/seller/quotations"
          icon={FaClipboardList}
          name="Cotações"
        />
        <Link
          to="/seller/profile"
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors duration-200 ${
            isActive("/seller/profile")
              ? "text-slate-900"
              : "text-slate-400 hover:text-slate-600"
          }`}
        >
          <UserAvatar
            src={user?.picture}
            alt="Perfil"
            className={`w-6 h-6 rounded-full object-cover ${
              isActive("/seller/profile") ? "ring-2 ring-slate-900" : ""
            }`}
            fallback={<FaUser className="w-5 h-5" />}
          />
          <span className="text-[10px] mt-1 font-medium leading-none">
            Perfil
          </span>
        </Link>
      </div>
    </nav>
  );
};

export default SellerBottomNav;
